// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1_CNQ","subheader":"ReorderModal_subheader__1nhSa","listWrap":"ReorderModal_listWrap__1sw-B"};